import { displayLanguageFormattedDate } from "gw-capability-fnol-adac-react";

export default {
    formatShortDate: (date) => {
        return displayLanguageFormattedDate(date, 'de', false);
    }
};
